import * as Yup from "yup";

const verificationCodeRegex = /^[0-9]+$/g;

export const VerificationSchema = Yup.object().shape({
  userVerificationCode: Yup.string()
    .required("שדה זה חובה למילוי")
    .matches(verificationCodeRegex, "קוד שגוי - נסה שנית")
});